import { writable } from "svelte/store";

import type { PickupWarehouse } from "@shared/types/PickupWarehouse";

export type PickupWarehousesRequest = {
  pickupWarehouses: PickupWarehouse[];
  loaded: boolean;
  failed: boolean;
};

export const initialPickupWarehousesState: PickupWarehousesRequest = {
  loaded: false,
  failed: false,
  pickupWarehouses: [],
};

export const pickupWarehousesStore = writable<PickupWarehousesRequest>(
  initialPickupWarehousesState,
);
